import React, { useContext, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import UserContext from "../../../utils/Contexts/UserContext";
import axiosInstance from "../../../utils/Requests/axios";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";

function DeleteAccount() {
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const [isChecked, setIsChecked] = useState(false);
  const { themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };

  const handleDeleteWebsite = async () => {
    const url = `/settings/users/${userData?.uuid}/profile`;

    try {
      await axiosInstance.delete(url);
      toast.success(
        t(
          "Your data is being deleted. We've received your confirmation to delete your data and we're in the process of deleting your data. Your account will no longer be accessible, and will be deleted per your request. For any further assistance, contact Support"
        )
      );
      await axiosInstance.post("/auth/logout");
      navigate("/sign-in")
    } catch (error) {
      toast.error(t("There was an error deleting the Account"));
    }
  };

  return (
    <div
      id="DeleteAccount"
      className={`card cardSetting ${themeStatus?.[selectedTheme]}`}
    >
      <div className="card-header">
        <h4 className="card-title">{t("Delete Your Account")}</h4>
      </div>

      <div className="card-body">
        <p className="responsive-text" style={{ color: "var(--whiteToBlack)" }}>
          {t(
            "When you delete your account, you lose access to Front account services, and we permanently delete your personal data. You can cancel the deletion for 14 days."
          )}
        </p>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="deleteAccountCheckbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <label
            className="form-check-label"
            htmlFor="deleteAccountCheckbox"
            style={{
              color: "rgba(145, 146, 147, 1)",
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            {t("Confirm that I want to delete my account.")}
          </label>
        </div>
      </div>
      <div className="card-header p-0"></div>
      <div className="d-flex justify-content-end gap-3 card-body pt-3">
        {/* eslint-disable-next-line */}
        <a href="javascript:;"
          className="btn btn-outline-primary responsive-btn p-0 "
        >
          {t("Learn More")}
        </a>
        <button
          className="btn btn-danger delete-btn p-0"
          onClick={handleDeleteWebsite}
          disabled={!isChecked}
        >
          {t("Delete")}
        </button>
      </div>
    </div>
  );
}

export default DeleteAccount;
